exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.glyphicon{\n    padding-right: 5px;\n}\n\na{\n    cursor: pointer;\n}\n\n.escape-html{\n    white-space: pre-wrap;\n}\n\n.star{\n    color: #ed1d24;\n    margin-left: 2px;\n}\n\n.wrong-clr {\n    color: #d27a78;\n}\n.right-clr {\n    color: #3e863e;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/agira/Desktop/BU-Intra/agira-intranet-ui/node_modules/postcss-loader?{"ident":"postcss"}!/home/agira/Desktop/BU-Intra/agira-intranet-ui/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles